module.exports = __webpack_public_path__ + "img/rating_2.78109682.png";